import React from 'react';
import { Button, notification } from 'antd';
import { NetworkLayer } from '../../../services/common';

// Instantiated lazily, not at module scope. There is an import cycle here
// (services/api -> keycloak -> authentication -> util -> appUtils -> crsRiskDetail
// -> AssocTransaction -> this file -> services/common -> apiModules/CommonPageModules),
// so building a NetworkLayer at import time runs while CommonPageModules is still
// initialising and `CommonModule` is not yet exported ("is not a constructor").
// Deferring to first use keeps the single-instance behaviour and breaks the cycle.
let commonService;
const getCommonService = () => {
  if (!commonService) commonService = new NetworkLayer();
  return commonService;
};

// Exported for unit testing the click handler in isolation (FIN-13177 [adversarial S8]).
export const DownloadButton = ({ jobId, notificationKey }) => (
  <Button
    type="primary"
    size="small"
    onClick={async (e) => {
      e.stopPropagation();
      try {
        const response = await getCommonService().amlsDownloadUrlAPI(jobId);
        if (response?.downloadUrl) {
          window.open(response.downloadUrl, '_blank');
        } else {
          // FIN-13177 [adversarial S8] — a job can still read status=COMPLETED here while
          // its S3 object has already crossed its TTL (the BE's expiry sweep is lazy, not
          // instantaneous). GET /downloads/:jobId/url already reports that case with a 404
          // + a human `msg` ("Export has expired..."); previously this branch silently did
          // nothing, so the "ready for download" link looked broken with no explanation.
          notification.error({
            message: 'Download unavailable',
            description:
              response?.msg ||
              'This export is no longer available. Please regenerate it.'
          });
        }
      } catch (err) {
        console.error('Failed to fetch download URL:', err);
        notification.error({
          message: 'Download unavailable',
          description: 'This export is no longer available. Please regenerate it.'
        });
      }
      notification.close(notificationKey);
    }}>
    Download
  </Button>
);

export const showExportReadyNotification = (response, options = {}) => {
  const notificationKey = `export-ready-${response.jobId}`;
  const { onNavigate } = options;

  const handleNotificationClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  notification.success({
    key: notificationKey,
    message: 'Export Ready',
    description:
      response?.message ||
      'This export has already been generated and is ready for download.',
    btn: (
      <DownloadButton
        jobId={response.jobId}
        notificationKey={notificationKey}
      />
    ),
    duration: 0,
    onClick: handleNotificationClick,
    style: onNavigate ? { cursor: 'pointer' } : {}
  });
};
